import type { SVGProps } from 'react'
const SvgToggleEnable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={28}
    fill="none"
    cursor="pointer"
    viewBox="0 0 44 28"
    {...props}
  >
    <rect width={44} height={28} fill="#2196F3" rx={14} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M30 26c6.627 0 12-5.373 12-12S36.627 2 30 2 18 7.373 18 14s5.373 12 12 12"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgToggleEnable
